import React from 'react'
import { ErrorModal } from './../../ui'
import { subscriptionHelpers } from '../../../dataHelpers'
import { getStorage, TOKEN_STORAGE_KEY, authRedirect } from '../../../dataHelpers/authenticationHelpers'
import '../../../stylesheets/Provision.css'
import { Button, Form, FormGroup, Input, Label, InputGroup, Nav, NavItem, NavLink, InputGroupAddon } from 'reactstrap'
import { AppError } from "../../../models"
import EditPlanIcon from 'react-icons/lib/fa/edit'
import AddPlanIcon from 'react-icons/lib/fa/plus-square'
import ExtendIcon from 'react-icons/lib/fa/expand'
import SubsListIcon from 'react-icons/lib/fa/list'
import classnames from 'classnames'
import tapOrClick from 'react-tap-or-click'
import Loader from 'react-loader-spinner'
import {
    NO_VALUE, SELECT_SUBS_PLAN, ENTER_SUBS_PLAN_DAYS, VALID_SUBS_PLAN_DAYS, SUCCESS, INITIAL_PLAN_UPDATE,
    NO_YEAR, SELECT_PLAN_YEAR, ENTER_SUBS_PLAN_PRICE, VALID_SUBS_PLAN_PRICE, SUBS_PLAN_PRICE_UPDATE
} from '../../../constants'

class EditSubscriptionPlan extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: false,
            subsPlanVal: '',
            activeTab: '2',
            freePlanData: [],
            paidPlanData: [],
            isFreePlan: false,
            planYear: '',
            planPrice: '',
            selectPlanID: '',
            planYearData: []
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.submitForm = this.submitForm.bind(this)
        this.onChange = this.onChange.bind(this)
        this.dismissError = this.dismissError.bind(this)
        this.fetchSubsPlanList = this.fetchSubsPlanList.bind(this)
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
        this.handleCheckboxYear = this.handleCheckboxYear.bind(this)
        this.handleCheckboxPlan = this.handleCheckboxPlan.bind(this)
    }

    async componentDidMount() {
        if (this.token) {
            this.fetchSubsPlanList()
        }
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    onChange(e) {
        this.setState({ subsPlanVal: e.target.value })
    }

    async fetchSubsPlanList() {
        let planlistResponse = await subscriptionHelpers.getPlanList(this.token)
        if (!planlistResponse.error) {
            let freePlanList = planlistResponse.filter(c => ((c.is_seasoned) === false))
            let paidPlanList = planlistResponse.filter(c => ((c.is_seasoned) === true))
            this.setState({ freePlanData: freePlanList, paidPlanData: paidPlanList })
        } else {
            this.setState({ errors: [planlistResponse.error] })
        }
    }

    async submitForm(e) {
        e.preventDefault()
        this.setState({ loading: true })
        let { subsPlanVal, selectPlanID, planPrice, planYear, isFreePlan } = this.state
        if (!selectPlanID || selectPlanID === '') {
            let appError = new AppError(NO_VALUE, SELECT_SUBS_PLAN)
            await this.setState({ errors: [appError], loading: false })
            return
        }
        if (isFreePlan) {
            subsPlanVal = subsPlanVal.toString()
            if (!subsPlanVal || !subsPlanVal.length) {
                let appError = new AppError(NO_VALUE, ENTER_SUBS_PLAN_DAYS)
                await this.setState({ errors: [appError], loading: false })
                return
            }
            if (!subsPlanVal.match(/^\d+(\.\d+)?$/)) {
                let appError = new AppError(NO_VALUE, VALID_SUBS_PLAN_DAYS)
                await this.setState({ errors: [appError], loading: false })
                return
            }
            let setSubsDaysResponse = await subscriptionHelpers.setInitialSubsDays(this.token, subsPlanVal, selectPlanID)
            if (!setSubsDaysResponse.error) {
                let appError = new AppError(SUCCESS, INITIAL_PLAN_UPDATE)
                await this.setState({ errors: [appError], loading: false, subsPlanVal: '' })
                return     
            } else {
                this.setState({ errors: [setSubsDaysResponse.error] })
            }
        } else {
            if (!planYear || !planYear.length) {
                let appError = new AppError(NO_YEAR, SELECT_PLAN_YEAR)
                await this.setState({ errors: [appError], loading: false })
                return
            }
            if (!planPrice || !planPrice.length) {
                let appError = new AppError(NO_VALUE, ENTER_SUBS_PLAN_PRICE)
                await this.setState({ errors: [appError], loading: false })
                return
            }
            if (!planPrice.match(/^\d+(\.\d+)?$/)) {
                let appError = new AppError(NO_VALUE, VALID_SUBS_PLAN_PRICE)
                await this.setState({ errors: [appError], loading: false })
                return
            }
            let subsPlanPriceResponse = await subscriptionHelpers.updatePlanPrice(this.token, planPrice, planYear, selectPlanID)
            if (!subsPlanPriceResponse.error) {
                let appError = new AppError(SUCCESS, SUBS_PLAN_PRICE_UPDATE)
                await this.setState({ errors: [appError], loading: false, planPrice: '', planYear: '', planYearData: [] })
                return                      
            } else {
                this.setState({ errors: [subsPlanPriceResponse.error] })
            }
        }
    }

    handleCheckboxChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value,
            selectPlanID: ''
        });
    }

    handleCheckboxPlan(evt) {
        let planId = evt.target.value
        let paidPlan = this.state.paidPlanData
        let freePlan = this.state.freePlanData
        let isFreePlan = this.state.isFreePlan
        if (isFreePlan) {
            if (planId) {
                let freePlanDays = freePlan.filter(e => parseInt(e.id) === parseInt(planId))
                let plandaysVal = freePlanDays[0].subscription_days
                this.setState({ selectPlanID: planId, subsPlanVal: plandaysVal })
            } else {
                this.setState({ selectPlanID: '', subsPlanVal: '' })
            }
        } else {
            if (planId) {
                let paidPlanYear = paidPlan.filter(e => parseInt(e.id) === parseInt(planId))
                this.setState({ selectPlanID: planId, planYearData: paidPlanYear })
            } else {
                this.setState({ selectPlanID: '', planYearData: '', planPrice: '' })
            }
        }
    }

    handleCheckboxYear(evt) {
        let selectPlanYear = evt.target.value
        let planId = this.state.selectPlanID
        let planYearArr = this.state.planYearData
        if (planYearArr && planYearArr.length > 0) {
            let planPrices = planYearArr.map((yeardata) => (
                yeardata.SubscriptionPlanPrice_set.filter(e => e.subscription_year === selectPlanYear)))
            let planPriceVal = planPrices[0][0].subscription_price
            this.setState({ selectPlanID: planId, planPrice: planPriceVal, planYear: selectPlanYear })
        } else {
            this.setState({ selectPlanID: planId, planPrice: '' })
        }
    }

    render() {
        let { errors, loading, subsPlanVal, freePlanData, paidPlanData, isFreePlan, planPrice, planYear, planYearData } = this.state
        return (<div>
            <div className="m-0 p-0">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptionsetting`, this.props.history)) })}
                        >
                            <AddPlanIcon />&ensp;Create Plan
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptioninitialplan`, this.props.history)) })}
                        >
                            <EditPlanIcon />&ensp;Edit Plan
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptionsetting/extendsubscription`, this.props.history)) })}
                        >
                            <ExtendIcon />&ensp;Extend Plan
                            </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '4' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptionplanlist`, this.props.history)) })}>
                            <SubsListIcon />&ensp;Available Plans
                            </NavLink>
                    </NavItem>
                </Nav>
            </div>
            <div className="row justify-content-center align-items-center bg-light large-rounded border-light-sf-orange p-0 pb-4">
                <h1 className="text-center mb-4 form-head col-12">Edit Subscription Plan</h1>
                {loading ?
                    <Loader type="TailSpin" width={60} height={60} /> :
                    <Form onSubmit={this.submitForm} className="col-lg-6 col-md-8 col-sm-10">
                        <FormGroup>
                            <div className="text-left">
                                <Label>Subscription Plan</Label>
                            </div>
                            <InputGroup>
                                <Input type="select" name="selectPlanID"
                                    onChange={this.handleCheckboxPlan}                                
                                >
                                    <option value="">&ensp;Select Subscription Plan</option>
                                    {isFreePlan ?
                                        (freePlanData ? freePlanData.map((plandata) => (
                                            <option key={`${plandata.id}`}
                                                value={plandata.id}>&ensp;{plandata.name}</option>
                                        )) : '') :
                                        (paidPlanData ? paidPlanData.map((plandata) => (
                                            <option key={`${plandata.id}`}
                                                value={plandata.id}>&ensp;{plandata.name}</option>
                                        )) : '')
                                    }
                                </Input>
                            </InputGroup>
                            <br />
                            <div className="text-left" style={{ marginLeft: '20px' }}>
                                <Input type="checkbox"
                                       name="isFreePlan"
                                       checked={this.state.isFreePlan}
                                       onChange={this.handleCheckboxChange}
                                />&ensp;
                                <Label>Set as Free Trial Plan</Label>
                            </div>
                            <br />
                            {isFreePlan ?
                                <div className="text-left">
                                    <Label>Initial Subscription Free Plan Days</Label>
                                    <InputGroup>
                                        <Input type="setinitialvalue"
                                            placeholder={`0`}
                                            value={subsPlanVal}
                                            onChange={this.onChange}
                                            maxLength={3}
                                        />
                                        <InputGroupAddon addonType="append">days</InputGroupAddon>
                                    </InputGroup>
                                </div>
                                :
                                <div>
                                    <div className="text-left">
                                        <Label>Subscription Plan Year</Label>
                                        <InputGroup>
                                            <Input type="select" name="selectPlanYear"
                                                onChange={this.handleCheckboxYear}                                            
                                            >
                                                <option value=''>Select Subscription Plan Year</option>
                                                {(planYearData && planYearData.length > 0) ?
                                                    planYearData.map((yeardata) => (
                                                        yeardata.SubscriptionPlanPrice_set.map((year) =>
                                                            <option key={`${year.id}`}
                                                                value={year.subscription_year}>&ensp;{year.subscription_year}</option>
                                                        ))
                                                    )
                                                    : null}
                                            </Input>
                                        </InputGroup>
                                    </div><br />
                                    <div className="text-left">
                                        <Label>Subscription Plan Price</Label>
                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                                            <Input type="planPrice"
                                                placeholder={`0`}
                                                value={planPrice}
                                                onChange={(evt) => this.setState({ planPrice: evt.target.value })}
                                                maxLength={10}
                                            />
                                        </InputGroup>
                                    </div>
                                </div>
                            }
                            <br />
                        </FormGroup>
                        <Button>Update Plan</Button>
                    </Form>
                }
                {errors.map((appError, idx) =>
                    <ErrorModal key={`error-${appError.text}-${idx}`}
                        modal={true}
                        toggle={() => (this.dismissError(appError))}
                        text={appError.text}
                        title={appError.title} />
                )}
            </div>
        </div>)
    }
}
export default EditSubscriptionPlan



// WEBPACK FOOTER //
// ./src/components/pages/subscription/EditSubscriptionPlan.js